/* gl_textfield.directive.js */

"use strict";

var _ = require("lodash");

module.exports = function ($compile, $timeout) {
    return {
        restrict: "EA",
        replace: true,
        scope: {
            settings: "=",
            api: "=",
        },

        link: function (scope, element, attrs, controller) {
            var elInput;
            var elError;
            var elLabel;
            var elValue;

            var classInput = "gl-textfield-input";
            var classError = "gl-textfield-error";
            var classLabel = "gl-textfield-view-label";
            var classValue = "gl-textfield-view-value";
            var classInvalid = "gl-invalid";
            var classEmpty = "gl-empty";
            var classCapsLock = "gl-caps-lock";
            var classMouseOver = "gl-mouse-over";
            var classNumberUpArrow = "gl-number-up-arrow-pressed";
            var classNumberDownArrow = "gl-number-down-arrow-pressed";
            var classNumberSpinner = "gl-number-mouseover-spinner";

            scope.api = scope.api || {};

            // Default Settings
            scope._settings = {};
            scope._settings.name = undefined;
            scope._settings.id = undefined;
            scope._settings.placeholder = undefined;
            scope._settings.disabled = false;
            scope._settings.type = "text";
            scope._settings.max = undefined;
            scope._settings.min = undefined;
            scope._settings.maxLength = undefined;
            scope._settings.step = undefined;
            scope._settings.tabIndex = 0;
            scope._settings.useTabIndex = false;
            scope._settings.capsLocked = false;
            scope._settings.numberMouseOverSpinner = false;
            scope._settings.valid = true;
            scope._settings.label = undefined;
            scope._settings.error = undefined;
            scope._settings.editable = true;
            scope._settings.showLabel = false;
            scope._settings.numberSpinner = true;
            scope._settings.value = undefined;

            // MAP SETTINGS
            _.assign(scope._settings, scope.settings);

            // If number type make sure value is a number not a string
            if (scope._settings.type === "number" && _.isString(scope._settings.value)) {
                scope._settings.value = parseInt(scope._settings.value);
            }

            // if no label use placeholders value
            if (_.isUndefined(scope._settings.label) && _.isString(scope._settings.placeholder)) {
                scope._settings.label = scope._settings.placeholder;
            }

            if (_.isUndefined(scope._settings.title)) {
                scope._settings.title = scope._settings.label || scope._settings.placeholder;
            }

            if (angular.isFunction(scope.settings.onClick)) {
                scope._settings.onClick = function (evt) {
                    scope.settings.onClick(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onDblClick)) {
                scope._settings.onDblClick = function (evt) {
                    elInput[0].setSelectionRange(0, elInput.val().length);
                    scope.settings.onDblClick(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onKeyDown)) {
                scope._settings.onKeyDown = function (evt) {
                    scope.settings.onKeyDown(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onKeyPress)) {
                scope._settings.onKeyPress = function (evt) {
                    scope.settings.onKeyPress(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onKeyUp)) {
                scope._settings.onKeyUp = function (evt) {
                    scope.settings.onKeyUp(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onInput)) {
                scope._settings.onInput = function (evt) {
                    scope.settings.onInput(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onFocus)) {
                scope._settings.onFocus = function (evt) {
                    scope.settings.onFocus(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onBlur)) {
                scope._settings.onBlur = function (evt) {
                    scope.settings.onBlur(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onMouseOver)) {
                scope._settings.onMouseOver = function (evt) {
                    scope.settings.onMouseOver(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onMouseOut)) {
                scope._settings.onMouseOut = function (evt) {
                    scope.settings.onMouseOut(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onMouseMove)) {
                scope._settings.onMouseMove = function (evt) {
                    scope.settings.onMouseMove(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onMouseDown)) {
                scope._settings.onMouseDown = function (evt) {
                    scope.settings.onMouseDown(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onMouseUp)) {
                scope._settings.onMouseUp = function (evt) {
                    scope.settings.onMouseUp(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onChange)) {
                scope._settings.onChange = function (evt) {
                    scope.settings.onChange(evt, getEventObj());
                };
            }

            if (angular.isFunction(scope.settings.onUserChange)) {
                scope._settings.onUserChange = function (val) {
                    scope.settings.onUserChange(val, getEventObj());
                };
            }

            scope._settings.onValueChange = scope.settings.onValueChange;

            // Templates
            var templateInput =
                '<input type="' +
                scope._settings.type +
                '" class="' +
                classInput +
                '" data-ng-model="_settings.value" ';
            templateInput += scope._settings.id ? ' id="{{_settings.id}}" ' : "";
            templateInput += scope._settings.name ? ' name="{{_settings.name}}" ' : "";
            templateInput += scope._settings.title ? ' title="{{_settings.title}}" ' : "";
            templateInput += scope._settings.placeholder
                ? ' placeholder="{{_settings.placeholder}}" '
                : "";
            templateInput += scope._settings.disabled ? ' disabled="disabled" ' : "";
            templateInput += scope._settings.useTabIndex
                ? ' tabindex="{{_settings.tabIndex}}" '
                : "";
            templateInput += angular.isUndefined(scope._settings.maxLength)
                ? ""
                : ' maxlength="{{_settings.maxLength}}" ';
            templateInput += angular.isUndefined(scope._settings.step)
                ? ""
                : ' step="{{_settings.step}}" ';
            templateInput += ">";
            var templateError = '<p class="' + classError + '" data-ng-bind="_settings.error"></p>';
            var templateLabel =
                '<label class="' + classLabel + '" data-ng-bind="_settings.label"></label>';
            var templateValue = '<p class="' + classValue + '" data-ng-bind="_settings.value"></p>';

            var canViewMode = function () {
                var can = false;
                switch (scope._settings.type) {
                    case "text":
                    case "email":
                    case "url":
                    case "tel":
                    case "number":
                    case "search":
                        can = true;
                        break;
                }
                return can;
            };

            function getEventObj() {
                return {
                    id: scope._settings.id,
                    name: scope._settings.name,
                    settings: scope.settings,
                };
            }

            scope.api.setInvalid = function (msg) {
                scope._settings.valid = false;
                if (angular.isString(msg)) {
                    scope._settings.error = msg;
                } else {
                    scope._settings.error = undefined;
                }
                errorMsgCheck();
            };

            scope.api.setValid = function () {
                scope._settings.valid = true;

                errorMsgCheck();
            };

            scope.api.setValue = function (val) {
                scope._settings.value = val;
            };
            scope.api.getValue = function () {
                return scope._settings.value;
            };

            scope.api.setPlaceholder = function (placeholder) {
                var elPh = elInput.attr("placeholder");
                if (_.isUndefined(elPh)) {
                    elInput.attr("placeholder", "{{_settings.placeholder}}");
                    $compile(elInput)(scope);
                }
                scope._settings.placeholder = placeholder;
            };
            scope.api.getPlaceholder = function () {
                return scope._settings.placeholder;
            };

            scope.api.disable = function () {
                scope._settings.disabled = true;
                elInput.attr("disabled", true);
            };

            scope.api.enable = function () {
                scope._settings.disabled = false;
                elInput.removeAttr("disabled");
            };

            var getInputEl = function () {
                elInput = angular.element(templateInput);
                elInput.val(scope._settings.value);

                if (angular.isString(scope._settings.value) && scope._settings.value !== "") {
                    elInput.removeClass(classEmpty);
                } else {
                    elInput.addClass(classEmpty);
                }

                // event bindings
                if (angular.isFunction(scope._settings.onChange)) {
                    elInput.bind("change", scope._settings.onChange);
                }
                if (angular.isFunction(scope._settings.onClick)) {
                    elInput.bind("click", scope._settings.onClick);
                }
                if (angular.isFunction(scope._settings.onDblClick)) {
                    elInput.bind("dblclick", scope._settings.onDblClick);
                }
                if (angular.isFunction(scope._settings.onKeyDown)) {
                    elInput.bind("keydown", scope._settings.onKeyDown);
                }
                if (angular.isFunction(scope._settings.onKeyUp)) {
                    elInput.bind("keyup", scope._settings.onKeyUp);
                }
                if (angular.isFunction(scope._settings.onKeyPress)) {
                    elInput.bind("keypress", scope._settings.onKeyPress);
                }
                if (angular.isFunction(scope._settings.onInput)) {
                    elInput.bind("input", scope._settings.onInput);
                }
                if (angular.isFunction(scope._settings.onBlur)) {
                    elInput.bind("blur", scope._settings.onBlur);
                }
                if (angular.isFunction(scope._settings.onMouseOver)) {
                    elInput.bind("mouseover", scope._settings.onMouseOver);
                }
                if (angular.isFunction(scope._settings.onMouseOut)) {
                    elInput.bind("mouseout", scope._settings.onMouseOut);
                }
                if (angular.isFunction(scope._settings.onMouseMove)) {
                    elInput.bind("mousemove", scope._settings.onMouseMove);
                }
                if (angular.isFunction(scope._settings.onMouseDown)) {
                    elInput.bind("mousedown", scope._settings.onMouseDown);
                }
                if (angular.isFunction(scope._settings.onMouseUp)) {
                    elInput.bind("mouseup", scope._settings.onMouseUp);
                }

                if (angular.isFunction(scope._settings.onUserChange)) {
                    elInput.on("input", function (evt) {
                        $timeout(function () {
                            // need to allow angular time to set the data
                            var val = scope.api.getValue();
                            scope._settings.onUserChange(val);
                        }, 0);
                    });
                }

                // filter out letters for number types
                if (scope._settings.type === "number") {
                    elInput.bind("keydown", function (evt) {
                        if (evt.keyCode > 64 && evt.keyCode < 96) {
                            evt.preventDefault();
                        }
                    });
                }

                elInput.bind("keypress", function (event) {
                    if (event.charCode === 13) {
                        if (_.isFunction(scope._settings.onEnterKey)) {
                            scope._settings.onEnterKey();
                        }
                    }
                });

                /////////////////////////////////////////////////////////
                // CAPS LOCK
                elInput.bind("keypress", function (event) {
                    var code = event.charCode || event.keyCode;
                    var shift = event.shiftKey;
                    if (code > 96 && code < 123 && shift) {
                        elInput.removeClass(classCapsLock);
                        scope._settings.capsLocked = false;
                    } else if (code > 64 && code < 91 && !shift) {
                        elInput.addClass(classCapsLock);
                        scope._settings.capsLocked = true;
                    }
                });
                elInput.bind("keyup keydown", function (event) {
                    var code = event.charCode || event.keyCode;
                    //var shift = event.shiftKey;
                    if (code === 20 && scope._settings.capsLocked === true) {
                        elInput.removeClass(classCapsLock);
                        scope._settings.capsLocked = false;
                    }
                });
                // END CAPS LOCK
                /////////////////////////////////////////////////////////

                /////////////////////////////////////////////////////////
                // NUMBER SPINNER logic
                if (scope._settings.type === "number" && scope._settings.numberSpinner) {
                    elInput.bind("mouseover", function (evt) {
                        elInput.addClass(classMouseOver);

                        // necessary for cursor styling over spinner
                        elInput.bind("mousemove", function (evt) {
                            var rect = elInput[0].getBoundingClientRect();
                            var x = evt.offsetX || evt.clientX - $(evt.target).offset().left;
                            var y = evt.offsetY || evt.clientY - $(evt.target).offset().top;
                            if (x > rect.width - 20) {
                                if (y < rect.height / 2) {
                                    elInput.addClass(classNumberSpinner);
                                } else if (y > rect.height / 2) {
                                    elInput.addClass(classNumberSpinner);
                                }
                            } else {
                                elInput.removeClass(classNumberSpinner);
                            }
                        });
                    });

                    elInput.bind("mouseout", function (evt) {
                        elInput.removeClass(classMouseOver);
                        elInput.removeClass(classNumberSpinner);
                        elInput.off("mousemove");
                    });

                    elInput.bind("mousedown", function (evt) {
                        var rect = elInput[0].getBoundingClientRect();
                        var x = evt.offsetX || evt.clientX - $(evt.target).offset().left;
                        var y = evt.offsetY || evt.clientY - $(evt.target).offset().top;
                        if (x > rect.width - 20) {
                            if (y < rect.height / 2) {
                                elInput.addClass(classNumberUpArrow);
                                incrementVal();
                            } else if (y > rect.height / 2) {
                                elInput.addClass(classNumberDownArrow);
                                decrementVal();
                            }
                        }
                    });

                    elInput.bind("mouseup", function () {
                        elInput.removeClass(classNumberUpArrow);
                        elInput.removeClass(classNumberDownArrow);
                    });
                }
                // End NUMBER SPINNER logic
                /////////////////////////////////////////////////////////

                return $compile(elInput)(scope);
            };

            var unregisterWatch = scope.$watch("_settings.value", function (n, o) {
                emptyCheck();
                if (angular.isFunction(scope._settings.onValueChange)) {
                    scope._settings.onValueChange(n, o);
                }

                if (scope._settings.type === "number") {
                    if (n === null || _.isUndefined(n)) {
                        return;
                    }
                    if (!angular.isUndefined(scope._settings.max)) {
                        if (scope._settings.value > scope._settings.max) {
                            scope._settings.value = scope._settings.max;
                        }
                    }
                    if (!angular.isUndefined(scope._settings.min)) {
                        if (scope._settings.value < scope._settings.min) {
                            scope._settings.value = scope._settings.min;
                        }
                    }
                }
            });

            // IF CAN VIEW MODE
            if (canViewMode()) {
                scope.api.setLabel = function (label) {
                    scope._settings.label = label;
                };
                scope.api.getLabel = function () {
                    return scope._settings.label;
                };

                scope.api.view = function () {
                    setViewMode();
                };
                scope.api.edit = function () {
                    setEditMode();
                };
            }

            var setViewMode = function () {
                scope._settings.editable = false;
                element.children().remove();

                if (angular.isString(scope._settings.label)) {
                    elLabel = $compile(angular.element(templateLabel))(scope);
                    element.append(elLabel);
                }

                elValue = $compile(angular.element(templateValue))(scope);
                element.append(elValue);
            };

            var setEditMode = function () {
                scope._settings.editable = true;
                element.children().remove();
                if (angular.isString(scope._settings.label) && scope._settings.showLabel) {
                    elLabel = $compile(angular.element(templateLabel))(scope);
                    element.append(elLabel);
                }
                element.append(getInputEl());
                errorMsgCheck();
                emptyCheck();
            };

            var emptyCheck = function () {
                if (!angular.isUndefined(elInput)) {
                    if (scope._settings.type === "number") {
                        if (
                            angular.isNumber(scope._settings.value) &&
                            scope._settings.value !== null
                        ) {
                            elInput.removeClass(classEmpty);
                        } else {
                            elInput.addClass(classEmpty);
                        }
                    } else {
                        if (
                            angular.isString(scope._settings.value) &&
                            scope._settings.value.length > 0
                        ) {
                            elInput.removeClass(classEmpty);
                        } else {
                            elInput.addClass(classEmpty);
                        }
                    }
                }
            };

            var timeoutPromise;
            var errorMsgCheck = function () {
                if (!angular.isUndefined(elError)) {
                    elError.remove();
                }
                if (scope._settings.editable) {
                    if (scope._settings.valid) {
                        elInput.removeClass(classInvalid);
                    } else {
                        elInput.addClass(classInvalid);
                        if (angular.isString(scope._settings.error)) {
                            timeoutPromise = $timeout(function () {
                                elError = $compile(angular.element(templateError))(scope); // ensure .error has been updated prior to this compile
                                element.append(elError);
                            }, 0);
                        }
                    }
                }
            };

            var incrementVal = function () {
                var val = scope.api.getValue();
                val++;
                if (isNaN(val)) {
                    val = 0;
                }
                scope.api.setValue(val);
                scope.$digest();
            };

            var decrementVal = function () {
                var val = scope.api.getValue();
                val--;
                if (isNaN(val)) {
                    val = 0;
                }
                scope.api.setValue(val);
                scope.$digest();
            };

            if (
                canViewMode() &&
                !angular.isUndefined(scope._settings.view) &&
                scope._settings.view === true
            ) {
                setViewMode();
            } else {
                setEditMode();
            }

            scope.$on("$destroy", function () {
                unregisterWatch();
                elInput.unbind();
                $timeout.cancel(timeoutPromise);
            });

            element.on("$destroy", function () {
                unregisterWatch();
                elInput.unbind();
                $timeout.cancel(timeoutPromise);
            });
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['$compile','$timeout'];